(function () {
    'use strict';

    angular
        .module('appback')
        .factory('PedidoproveedorService', PedidoproveedorService);

    PedidoproveedorService.$inject = ['$http'];

    function PedidoproveedorService($http) {

        var service = {
            getProveedores: getProveedores,
            getProductosProveedor: getProductosProveedor,
            generarPedido: generarPedido,
        };

        return service;

        function getProveedores() {
            return $http.get('/backend/pedidoproveedor/getproveedores');
        }

        function getProductosProveedor(proveedorId) {
            return $http.get('/backend/pedidoproveedor/getproductosproveedor', {
                params: {
                    proveedor_id: proveedorId
                }
            });
        }

        function generarPedido(datos) {
            var config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param(datos);
            return $http.post('/backend/pedidoproveedor/generarpedido', data, config)
        }

    }
})();